module.exports = __webpack_public_path__ + "f04d2fb280d2d86a4f68bc3b8a483a3c.svg";